
const CardsCol3 = ({ itemsData, language = '' }: { itemsData: any, language?: string }) => {
    const header = itemsData?.Header || {};
    const itemList = itemsData?.Item || [];
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';
    if (!header.ColorOne && itemList.length === 0) return null;

    return (
        <>
            {header.ColorOne && (
                <h2 className='h2-main'>
                    {header.ColorOne}{language == "en" ? " " : ""}<span>{header.ColorTwo}</span>
                </h2>
            )}
            <div className='item-container'>
                {itemList.map((item: any, index: number) => {
                    return (
                        <div className='item' key={index}>
                            <a href={"/"+language + item.Url} className='url' area-label={item.Title || ''}></a>
                            <div>
                                <h3>
                                    <span>
                                        <img src={`${locateSrc}${item.Icon?.url}`} alt={item.Title || ''} />
                                    </span>
                                    {item.Title}
                                </h3>
                                <div>{item.Content}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default CardsCol3;
